import { useEffect } from "react";
import { elevationDark, neutralLight } from "@crehana/tailwindcss";
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { Clamp } from "@crehana/ui";
import cn from "clsx";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SubMenuDesktopLink = function SubMenuDesktopLink(_ref) {
  var route = _ref.route,
    isDark = _ref.isDark,
    _ref$decorationType = _ref.decorationType,
    decorationType = _ref$decorationType === void 0 ? 'left-line' : _ref$decorationType,
    isSelectedURL = _ref.isSelectedURL,
    onSelectedChange = _ref.onSelectedChange,
    onClick = _ref.onClick,
    _ref$isSidebarV2Enabl = _ref.isSidebarV2Enabled,
    isSidebarV2Enabled = _ref$isSidebarV2Enabl === void 0 ? false : _ref$isSidebarV2Enabl;
  var RightIcon = route.rightIcon;
  var isLeftLine = decorationType === 'left-line';

  // biome-ignore lint/correctness/useExhaustiveDependencies: dependencies are intentional
  useEffect(function () {
    if (onSelectedChange) {
      onSelectedChange(isSelectedURL);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSelectedURL]);
  var classNames = cn('tw-flex tw-items-center tw-w-full tw-h-3.6 tw-px-1.2 tw-text-left tw-rounded-[5px] tw-relative tw-z-2', {
    'tw-justify-between': !!RightIcon,
    // ------------ Light theme ------------
    'hover:bg-gray-lighter hover:text-base-main': !isDark,
    'bg-white text-gray-dark': !isSelectedURL && !isDark,
    // Not selected and not dark
    'tw-bg-neutral-light-300 text-primary-light': isSelectedURL && !isDark,
    // Selected and not dark
    // ------------ Dark theme -------------
    'hover:bg-gray-lighter-dark-mode': isDark,
    'bg-base-lighter-dark-mode text-secondary-light': isSelectedURL && isDark,
    // Selected and dark
    'bg-base-main text-gray-lighter': !isSelectedURL && isDark // Not selected and dark
  });
  var newSidebarClassNames = cn('tw-flex tw-items-center tw-w-full tw-h-3.6 tw-px-1.2 tw-text-left tw-rounded-[5px] tw-relative tw-z-2', {
    'tw-justify-between': !!RightIcon
  }, isSelectedURL ? 'tw-bg-neutral-dark-200 tw-text-primary-light-500' : 'tw-text-neutral-light-700 hover:tw-text-primary-light-500 hover:tw-bg-neutral-light-200',
  // Dark theme
  'dark:tw-text-neutral-dark-400 dark:hover:tw-text-secondary-dark-300 dark:hover:tw-bg-neutral-dark-700');
  return /*#__PURE__*/_jsxs("li", {
    className: cn('tw-my-0.8 relative', {
      'tw-ml-4 tw-pr-1.2': isLeftLine
    }, isSidebarV2Enabled ? 'tw-font-subtitle5' : 'tw-font-body4'),
    children: [/*#__PURE__*/_jsxs("button", {
      type: "button",
      onClick: onClick,
      className: isSidebarV2Enabled ? newSidebarClassNames : classNames,
      children: [/*#__PURE__*/_jsx(Clamp, {
        clamp: 1,
        children: route.label
      }), RightIcon && /*#__PURE__*/_jsx(RightIcon, {
        size: isSidebarV2Enabled ? 20 : 24,
        ignoreColor: true,
        className: "tw-fill-current"
      })]
    }), isLeftLine && /*#__PURE__*/_jsx("div", {
      className: cn('tw-absolute tw-z-1 tw-rounded-[5px] tw-h-4.8 tw-w-[20px] tw-bg-transparent tw-border-l-[2px] tw-border-b-[2px] tw-border-solid'),
      style: {
        top: '-28px',
        left: '-12px',
        borderBottomRightRadius: 0,
        borderColor: isDark ? elevationDark['04'] : neutralLight['300']
      }
    })]
  });
};
export default SubMenuDesktopLink;